import { LIVESTREAM_STORE_NAME } from 'models/liveStream/reducers';
import { LiveStreamState } from 'models/liveStream/types';
import { createSelector } from 'reselect';

const selectCurrentChannel = (state: any) => (state[LIVESTREAM_STORE_NAME] as LiveStreamState).currentChannel;
const selectIsClosable = (state: any) => (state[LIVESTREAM_STORE_NAME] as LiveStreamState).isClosable;
const selectBoothLiveStreamingLastTimeStamp = (state: any) => (state[LIVESTREAM_STORE_NAME] as LiveStreamState).boothLiveStreamingLastTimeStamp;
const selectBoothLiveStreamingStatus = (state: any) => (state[LIVESTREAM_STORE_NAME] as LiveStreamState).boothLiveStreamingStatus;

// eslint-disable-next-line import/prefer-default-export
export const liveStreamSelectors = {
  selectCurrentChannel,
  selectIsClosable,
  selectBoothLiveStreamingLastTimeStamp,
  selectBoothLiveStreamingStatus,
};

export const liveStreamingStatusSelector = (boothId: string) => createSelector(
  selectBoothLiveStreamingStatus,
  (status) => status[boothId],
);
